export default function(state=[], action) {

    switch(action.type) {
        
        case "ACTIVITIES":
            return action.payload;

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/ReducerActivitiesInDomain.js